import React from 'react'
import errorImg from "../assets/404 1.svg"
import { Link,useNavigate } from 'react-router-dom'
import LogoPngImg from "../assets/Mothers-Pride-Logo-1024x283 6.png"
import { useEffect } from 'react'


const NotFound = () => {
    const navigate=useNavigate();
    useEffect(()=>{
        const timer=setTimeout(()=>{
            navigate('/');
        },5000)
        return ()=>{clearTimeout(timer)}
    },[])

  return (
    <div className='px-[8%]  pb-[3%] bg-white flex flex-col items-center'>
        <img src={errorImg} alt='notFoundImg' className=' w-[600px] mx-auto'/>
        <h1 className='font-Lato text-[#565872] text-3xl mt-[100px]'>Oops Not Found!</h1>
        <div className="flex items-center mt-5 justify-center">
          <Link to="/">
            <img
              src={LogoPngImg}
              className="h-[42px] object-fit"
              alt="Mothers Pride Logo"
            />
          </Link>
        </div>
    </div>
  )
}

export default NotFound